import { Avatar, Modal, Spin, Typography } from 'antd'
import Title from 'antd/es/typography/Title';
import React, { useEffect, useState } from 'react'
import { CommentsAPI } from '../../API/CommentsAPI';
import { UserOutlined } from '@ant-design/icons';
const { Text, Paragraph } = Typography;

export const ViewComments = ({ open, setOpen, selectedID, setOpenAddComments, messageToast }) => {
    const [commentsList, setCommentsList] = useState([]);
    const [loadSpin, setLoadSpin] = useState(false)

    useEffect(() => {
        if (open === true) listComments()
    }, [selectedID, open])

    async function listComments() {
        setLoadSpin(true)
        const bodyData = {
            id: selectedID
        }
        await CommentsAPI.viewComment(bodyData)
            .then(res => {
                res.data?.status === true ? setCommentsList(res.data?.data) : messageToast("error", res.data?.message)
            })
            .catch(err => {
                messageToast("error", "Internal Server Error")
            })
            .finally(() => setLoadSpin(false))
    }

    async function applyFun() {
        setOpen(false)
        setOpenAddComments(true)
    }

    return (

        <Modal
            open={open}
            okText='Add New Comment'
            cancelText='Cancel'
            onCancel={() => setOpen(false)}
            onOk={applyFun}
        >
            <Spin spinning={loadSpin}>
                <div style={{ padding: '0px' }}>
                    <div style={{ marginBottom: '20px', borderBottom: 'solid 1px #80808047' }}>
                        <Title level={5}>Comments of Spec No: <span style={{ color: '#304CB2' }}>{commentsList[0]?.spec_name}</span></Title>
                    </div>
                    <div className='scroll'>
                        {commentsList.length > 0 &&
                            commentsList.map((ele, index) => {
                                return <div className='comment_card' key={index}>
                                    <div style={{ display: 'flex', }}>
                                        <div style={{}}>
                                            <Avatar size="large" icon={<UserOutlined />} />
                                        </div>
                                        <div style={{ display: 'flex', flexDirection: 'column', paddingLeft: '15px' }}>
                                            <Text strong style={{ fontSize: '14px', color: '#000' }}>
                                                {ele.full_name}
                                            </Text>
                                            <Text type="secondary" style={{ fontSize: '13px', }}>
                                                {ele.created_on}
                                            </Text>
                                        </div>
                                    </div>
                                    <div style={{ marginTop: '10px' }}>
                                        <Paragraph style={{ marginBottom: '0px' }}>
                                            {ele.comment}
                                        </Paragraph>
                                    </div>
                                </div>
                            })}
                    </div>
                </div>
            </Spin>
        </Modal>
    )
}
